import {
  DEFAULT_HOTSPOT_BEACON_STYLE,
  HotspotBeaconStyle
} from '@/features/demo/dto/FrameTooltipDTO';

export const HOTSPOT_DOT_RATIO: Record<HotspotBeaconStyle, number> = {
  ring: 0.4,
  filled: 0.75
};

export const resolveHotspotBeaconStyle = (style?: HotspotBeaconStyle | null): HotspotBeaconStyle =>
  style || DEFAULT_HOTSPOT_BEACON_STYLE;

export const getHotspotDotRatio = (style?: HotspotBeaconStyle | null): number =>
  HOTSPOT_DOT_RATIO[resolveHotspotBeaconStyle(style)];

export const stripHtmlToText = (html?: string | null): string => {
  if (!html) return '';
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};
